import constants from "../constants";

const { SET_CLOUD_APIS_APARTMENT } = constants;

// eslint-disable-next-line import/prefer-default-export
export const setCloudApisApartment = (data) => ({
  type: SET_CLOUD_APIS_APARTMENT,
  data,
});
